import { EmotionIconProps } from '@emotion-icons/emotion-icon'

export const RankIcon = (props: EmotionIconProps) => {
  const { fill, color, size } = props
  return (
    <svg height={size} viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="6.2002" width="3" height="12" fill={fill || color || 'currentColor'} />
      <rect x="12.5" y="9.2002" width="3" height="9" fill={fill || color || 'currentColor'} />
      <rect x="6.5" y="0.200195" width="3" height="18" fill={fill || color || 'currentColor'} />
    </svg>
  )
}
